// @ts-nocheck
import React from 'react';

export const validateCompanyDomain = (value) => {
  if (!value || !value.trim()) return true;
  const urlRegex = /^https?:\/\/([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/.*)?$/;
  return urlRegex.test(value.trim());
};

export const DOMAIN_ERROR_MESSAGE = 'Please enter a valid URL (e.g., https://example.com)';

const LOGO_MAX_BYTES = 10 * 1024 * 1024;
const LOGO_EXTENSIONS = ['jpg', 'jpeg', 'png'];

export function handleCompanyLogoChange(event, { setLogoFile, setLogoPreview, setLogoError }) {
  const file = event?.target?.files?.[0];

  setLogoError('');

  if (!file) {
    setLogoFile(null);
    setLogoPreview(null);
    return;
  }

  const extension = String(file.name).split('.').pop()?.toLowerCase();

  if (!LOGO_EXTENSIONS.includes(extension)) {
    setLogoError('Only jpg, jpeg and png files are allowed');
    setLogoFile(null);
    setLogoPreview(null);
    return;
  }

  if (file.size > LOGO_MAX_BYTES) {
    setLogoError('Logo must be 10MB or smaller');
    setLogoFile(null);
    setLogoPreview(null);
    return;
  }

  setLogoFile(file);

  const reader = new FileReader();
  reader.onload = () => setLogoPreview(reader.result);
  reader.readAsDataURL(file);
}

export default function CompanyBrandingFields({
  domain,
  setDomain,
  domainError,
  setDomainError,
  panelDisplayName,
  setPanelDisplayName,
  logoPreview,
  logoError,
  onLogoChange,
  /* Logo already stored on the company, shown until a new file is picked. */
  existingLogoUrl = null,
}) {
  const runDomainValidation = (value) => {
    setDomainError(value.trim() && !validateCompanyDomain(value) ? DOMAIN_ERROR_MESSAGE : '');
  };

  const preview = logoPreview || existingLogoUrl;

  return (
    <>
      <div className="row user-create-form__row">
        <div className="col-12 col-lg-6 form-group mb-0">
          <label className="form-label" htmlFor="company-branding-domain">
            Domain <small className="text-muted">(Optional)</small>
          </label>
          <input
            id="company-branding-domain"
            type="text"
            className={`form-control${domainError ? ' is-invalid' : ''}`}
            placeholder="https://example.com"
            maxLength={500}
            value={domain || ''}
            onChange={(e) => {
              setDomain(e.target.value);
              runDomainValidation(e.target.value);
            }}
            onBlur={(e) => runDomainValidation(e.target.value)}
          />
          {domainError && <div className="invalid-feedback d-block">{domainError}</div>}
        </div>

        <div className="col-12 col-lg-6 form-group mb-0">
          <label className="form-label" htmlFor="company-branding-panel-name">
            Panel Display Name{' '}
            <small className="text-muted">(Optional - inherits from parent company)</small>
          </label>
          <input
            id="company-branding-panel-name"
            type="text"
            className="form-control"
            placeholder="e.g. My Company Portal"
            value={panelDisplayName || ''}
            onChange={(e) => setPanelDisplayName(e.target.value)}
            maxLength={200}
          />
        </div>
      </div>

      <div className="row user-create-form__row">
        <div className="col-12 col-lg-6 form-group mb-0">
          <label className="form-label" htmlFor="company-branding-logo">
            Logo <small className="text-muted">(Optional - jpg/jpeg/png, max 10MB)</small>
          </label>
          <input
            id="company-branding-logo"
            type="file"
            className="form-control"
            accept=".jpg,.jpeg,.png"
            onChange={onLogoChange}
          />
          {logoError && <div className="text-danger small mt-1">{logoError}</div>}
          {preview && (
            <div className="mt-2">
              <img
                src={preview}
                alt="Logo preview"
                style={{
                  width: '70px',
                  height: '70px',
                  objectFit: 'contain',
                  borderRadius: '50%',
                  border: '2px solid #dee2e6',
                }}
              />
              <div className="text-muted small mt-1">Preview (displayed as 70x70)</div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
